import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface LoadErrorStateProps {
  error: Error;
  onRetry: () => void;
  onRefresh: () => void;
  sectionName?: string;
}

export const LoadErrorState: React.FC<LoadErrorStateProps> = ({
  error,
  onRetry,
  onRefresh,
  sectionName = 'section'
}) => {
  return (
    <div className="w-full px-6 py-10 flex flex-col items-center justify-center text-center">
      <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400">
        <AlertCircle size={24} />
      </div>
      <div className="text-sm font-medium theme-text mb-1">
        Failed to load {sectionName}
      </div>
      <div className="text-xs theme-text-muted mb-4 max-w-md">
        {error.message || 'An error occurred while loading data'}
      </div>
      <div className="flex gap-2">
        <button
          onClick={onRetry}
          className="inline-flex items-center gap-2 rounded-lg border theme-border theme-surface px-3 py-2 text-sm font-medium theme-text hover:theme-muted transition-colors"
          aria-label="Retry loading"
        >
          <RefreshCw size={16} />
          Retry
        </button>
        <button
          onClick={onRefresh}
          className="inline-flex items-center gap-2 rounded-lg border theme-border theme-surface px-3 py-2 text-sm font-medium theme-text hover:theme-muted transition-colors"
          aria-label="Refresh page"
        >
          <RefreshCw size={16} />
          Refresh
        </button>
      </div>
    </div>
  );
};

